export default __webpack_public_path__ + "static/media/b2.db1f122f.png";